import {Country} from './Country';
import {Product} from './Product';

export class Price {
  public id: number;
  public country: Country;
  public dealerPrice: number;
  public customerPrice: number;
  public discount: string;
  public product: Product|number;
}
